import type { DealFormData } from './types'

export const getDefaultDealFormData = (): DealFormData => ({
  projectName: '',
  description: '',
  summaryTraction: '',
  summaryTokenUtilityEconomics: '',
  summaryRoadmap: '',
  summaryCompetitiveLandscape: '',
  summaryRiskEvaluation: '',
  summaryProjectFeatures: '',
  summaryInvestmentThesis: '',
  teamMembers: [
    {
      id: 'team-0',
      role: '',
      name: '',
      customTitle: '',
    },
  ],
  projectMemo: '',
  logo: null,
  logoUrl: '',
  banner: null,
  bannerUrl: '',
  category: [],
  website: '',
  twitter: '',
  discord: '',
  otherUrl: '',
  pitchDeck: null,
  pitchDeckUrl: '',
  researchReport: '',
  researchNotes: '',
  requestResearch: false,
  researchPath: 'link',
  requestResearchSupport: false,
  urls: [
    { id: 'website', type: 'website', url: '' },
    { id: 'x', type: 'x', url: '' },
  ],
  investors: [''],
  researchMaterials: 'link',
  capTable: '',
  jurisdiction: '',
  jurisdictionOther: '',
  countryRestrictions: [],
  whitelistCsv: null,
  whitelistAddressCount: 0,

  pricingMethod: 'fixed',
  fdv: '',
  tokenPrice: '',
  tokenSupply: '',
  totalAllocation: '',
  minimumRaiseThreshold: '',
  maxRaise: '',
  minimumInvestmentPerUser: '',
  fixedPoolName: '',
  cliff: '',
  tgeRelease: '',
  linearVesting: '',
  flexibleSchedules: [],
  whitelistEntries: [],
  enableWhitelistAccess: false,
  referralEnabled: false,
  referralDiscountT1: '',
  referralDiscountT2: '',
  referralDiscountT3: '',
  referralKickbackT1: '',
  referralKickbackT2: '',
  referralKickbackT3: '',
  referralGeneralDiscount: '',
  referralGeneralKickback: '',
  referralCustomEntries: [],
  referralCustomCsv: null,
  distributionChain: '',
  depositChain: '',
  depositChainStablecoin: '',
  vaultChainId: '',
  vaultAddress: '',
  depositTokenAddress: '',
  depositTokenDecimals: '',
  depositTokenName: '',
  depositTokenSymbol: '',
  depositScheduleTBD: false,
  hideTimeline: true,
  // KYC is opt-out for vault deals. It must only be disabled after review.
  requiresKyc: true,
  vaultProtocolName: '',
  vaultExternalUrl: '',
  slug: '',
  v1SaleId: '',
  v1AllocationSaleId: '',
  v1TrackId: '',
  v1DepositChainId: '',
  v1DepositAddress: '',
  v1DepositPoolSize: '',
  v1DepositStartTime: '',
  v1DepositEndTime: '',
  v1RefundStartTime: '',
  v1RefundEndTime: '',
  v1ClaimChainId: '',
  v1ClaimAddress: '',
  v1ClaimTokenDecimals: '',
  v1ClaimTokenSymbol: '',
  v1SaleTokenAddress: '',
  v1SaleTokenDecimals: '',
  v1SaleTokenName: '',
  v1SaleTokenSymbol: '',
  v1DepositConfigs: [],
  v1DepositTokenPrice: '',
  v1TvlTargetTVL: '',
  v1TvlLockPeriodMonths: '',
  v1TvlNativeYieldAPR: '',
  v1TvlFees: '',
  v1TvlEarlyExitPenalty: '',
  v1TvlEarlyExitTokenSymbol: '',
  v1TvlRewardKind: '',
  v1TvlTokensPerDepositUnit: '',
  v1TvlRewardLabel: '',
  v1TvlWeeklyPool: [],
  v1TvlRewardTokenSymbol: '',
  v1TvlRewardTokenFdv: '',
  v1TvlRewardTokenTotalSupply: '',
  v1TvlRewardsPerMonth: '',
  v1TvlVestingDescription: '',

  projectTokenAddress: '',
  projectTokenSymbol: '',
  projectTokenName: '',
  projectTokenDecimals: '',

  lockdropDuration: '',
  lockdropStartDate: '',
  lockdropEndDate: '',
  targetTVL: '',
  targetYieldProposal: '',
  fdvLastRound: '',

  salesType: '',
  salesTypeDetail: '',

  projectWallet: '',
  hasAssetManager: '',
  assetManagerWallet: '',
  curatorCommitmentAmount: '',
  transactionLink: '',
  supportingDocuments: null,
  supportingDocumentsUrl: '',
  flatCommissionRate: '',
  carryCommissionRate: '',
  curatorCommissionWallet: '',
  stablecoinFeePercent: '',
  tokenFeePercent: '',
  commissionType: '',
  stablecoinCommission: '',
  tokenCommission: '',

  otcSettlementWallet: '',

  lockdropCuratorWallet: '',
  lockdropPerformanceFeesType: '',
  lockdropPerformanceFeesStablecoin: '',
  lockdropPerformanceFeesToken: '',
  lockdropManagementFeesType: '',
  lockdropManagementFeesStablecoin: '',
  lockdropManagementFeesToken: '',

  secondaryMarketEnabled: false,
  royaltyPercentage: '',
  transferRestrictions: '',
  withdrawalType: 0,

  purchaseStartDate: '',
  purchaseEndDate: '',
  mintStartDate: '',
  tgeTargetDate: '',
  launchDate: '',
  vestingStartDate: '',
  milestones: [],

  marketingGuidelinesAgreementAccepted: false,
  nftTransferability: 'immediate',
  customStartDateTime: '',
  accessoryServices: {
    marketing: false,
    kolCampaigns: false,
    marketMaking: false,
    treasuryManagement: false,
    otcDeals: false,
    auditing: false,
    hrRecruitment: false,
    cexListing: false,
    other: false,
    otherDescription: '',
  },
  royaltySplit: {
    project: '',
    curator: '',
  },
  submissionNotes: '',
  submittedAt: null,
  submissionStatus: 'draft',
  dealState: null,
})
